import { compose } from '@glitz/core';
import { createDevToolTransformer } from '@glitz/devtool-transformer';
import { createNumberToLengthTransformer } from '@glitz/length-transformer';
import prefixer from '@glitz/prefixer-transformer';

function transformers(options) {
    if (options === void 0) { options = {}; }
    return compose(prefixer, createDevToolTransformer(options.devToolOptions), createNumberToLengthTransformer(options.numberToLengthOptions));
}

export { transformers as default };
